module.exports = __webpack_public_path__ + "media/images/ln/horoscope_1-3dcac01c27bcc1fb74707358864ea143.png";